"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/icons.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

// Round 3's stroke icons for the inbox list (24px grid). They draw in
// `currentColor`, so the colour comes from the token on the parent.






const makeIcon = (paths) => {
  const StrokeIcon = ({ size = 16, className }) => (
    _react2.default.createElement('svg', {
      className: className,
      width: size,
      height: size,
      viewBox: "0 0 24 24"   ,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.75",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      'aria-hidden': "true",
      focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}

      ,  paths 
    )
  )
  return StrokeIcon
}

 const ArchiveIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "3", y: "4", width: "18", height: "5", rx: "1.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} )
  , _react2.default.createElement('path', { d: "M5 9v9a2 2 0 002 2h10a2 2 0 002-2V9M10 13h4"         , __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
)); exports.ArchiveIcon = ArchiveIcon

 const UnarchiveIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "3", y: "4", width: "18", height: "5", rx: "1.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} )
  , _react2.default.createElement('path', { d: "M5 9v9a2 2 0 002 2h10a2 2 0 002-2V9M12 17v-5M9.5 14.5L12 12l2.5 2.5"            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}} )
)); exports.UnarchiveIcon = UnarchiveIcon

 const MoreIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "5", cy: "12", r: "1", fill: "currentColor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
  , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "1", fill: "currentColor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} )
  , _react2.default.createElement('circle', { cx: "19", cy: "12", r: "1", fill: "currentColor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}} )
)); exports.MoreIcon = MoreIcon

 const MarkUnreadIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "3", y: "5", width: "18", height: "14", rx: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} )
  , _react2.default.createElement('path', { d: "M3.5 6.5L12 13l8.5-6.5"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} )
)); exports.MarkUnreadIcon = MarkUnreadIcon

 const PinIcon = makeIcon(
  _react2.default.createElement('path', { d: "M9 3.5h6M10 3.5v5.25L7 12.5V14h10v-1.5l-3-3.75V3.5M12 14v6.5"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}} ),
); exports.PinIcon = PinIcon

// A pinned row's marker (D-19): a filled push-pin, tilted like WhatsApp's.
// The same shape as mobile's pinFill.png.
 const PinnedIcon = ({ size = 16, className }) => (
  _react2.default.createElement('svg', { className: className, width: size, height: size, viewBox: "0 0 24 24"   , 'aria-hidden': "true", focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
    , _react2.default.createElement('path', {
      fill: "currentColor",
      transform: "translate(12 12) scale(1.15) translate(-12 -12) translate(-1 1) rotate(45 12 12)"         ,
      d: "M8.5 2.5h7a1 1 0 0 1 0 2H15v4.6l3.2 3.5c.6.65.14 1.7-.74 1.7H12.75v6.2L12 22l-.75-1.5v-6.2H6.54c-.88 0-1.34-1.05-.74-1.7L9 9.1V4.5h-.5a1 1 0 0 1 0-2z"                  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
    )
  )
); exports.PinnedIcon = PinnedIcon

 const UnpinIcon = makeIcon(
  _react2.default.createElement('path', { d: "M9 3.5h6M10 3.5v5.25L7 12.5V14h10v-1.5l-3-3.75V3.5M12 14v6.5M4 4l16 16"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}} ),
); exports.UnpinIcon = UnpinIcon

 const TeamIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "9", cy: "8", r: "3.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}} )
  , _react2.default.createElement('path', { d: "M2.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}} )
  , _react2.default.createElement('path', { d: "M16 4.5a3.5 3.5 0 010 7M21.5 20c0-2.6-1.6-4.4-4-5.2"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}} )
)); exports.TeamIcon = TeamIcon

 const MutedIcon = makeIcon(
  _react2.default.createElement('path', { d: "M18 8a6 6 0 00-9.3-5M6 8c0 7-3 9-3 9h13M13.7 21a2 2 0 01-3.4 0M3 3l18 18"               , __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}} ),
); exports.MutedIcon = MutedIcon

 const CheckIcon = makeIcon(_react2.default.createElement('path', { d: "M4 12l5 5L20 6"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}} )); exports.CheckIcon = CheckIcon

 const HeartIcon = makeIcon(
  _react2.default.createElement('path', { d: "M12 20s-7-4.4-7-9.6A3.9 3.9 0 0112 8a3.9 3.9 0 017 2.4C19 15.6 12 20 12 20z"              , __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}} ),
); exports.HeartIcon = HeartIcon

 const InboxIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('path', { d: "M3 13l3-8h12l3 8v6H3z"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}} )
  , _react2.default.createElement('path', { d: "M3 13h5l1 2h6l1-2h5"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}} )
)); exports.InboxIcon = InboxIcon

 const ClockIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "8.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}} )
  , _react2.default.createElement('path', { d: "M12 7.5V12l3 2"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}} )
)); exports.ClockIcon = ClockIcon

 const ChevronDownIcon = makeIcon(_react2.default.createElement('path', { d: "M6 9l6 6 6-6"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}} )); exports.ChevronDownIcon = ChevronDownIcon
